import { render, staticRenderFns } from "./CountrySub.vue?vue&type=template&id=5046c84d&scoped=true"
import script from "./CountrySub.vue?vue&type=script&lang=js"
export * from "./CountrySub.vue?vue&type=script&lang=js"
import style0 from "./CountrySub.vue?vue&type=style&index=0&id=5046c84d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5046c84d",
  null
  
)

export default component.exports